import Show from '../show'

const VendorRemittanceDashboard = () => {
  return (
    <Show
      title="Vendor Remittance Dashboard"
      dashboardKey="vr_dashboards"
      showYear={false}
    />
  )
}

export default VendorRemittanceDashboard
